<template>
    <div>
        <loading
            :active.sync="loadingContent"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Panduan</div>
        </div>
        <div id="appCapsule">
            <div class="section inset m-1 mt-3">
                <div
                    class="text-justify"
                    style="font-size: 12px; line-height: 150%"
                >
                    <h3>
                        Panduan: Pengajuan Permintaan Penghapusan Data Pribadi
                    </h3>
                    <p>
                        Mitra {{ VUE_ENV.VUE_APP_NAME }} dapat menarik
                        persetujuan sehubungan dengan pengumpulan, akuisisi,
                        penyimpanan, penggunaan, pemrosesan, pengontrolan,
                        transfer, transmisi, pengungkapan dan/atau dan
                        perlindungan atas Data Pribadi yang ditetapkan dalam
                        Kebijakan Privasi ini dan memohon penghapusan data
                        tersebut sepanjang diperbolehkan dan/atau tidak
                        ditentukan sebaliknya berdasarkan hukum dan peraturan
                        perundang-undangan yang berlaku dengan mengajukan
                        permintaan melalui Fitur "Hapus Data Akun" pada Aplikasi
                        {{ VUE_ENV.VUE_APP_NAME }}.
                    </p>
                    <!-- <p>Silahkan ikuti panduan dan tips berikut:</p> -->
                    <p><strong>Syarat & Ketentuan</strong></p>
                    <p>
                        Mitra {{ VUE_ENV.VUE_APP_NAME }} harus memperhatikan
                        hal-hal berikut sebelum melakukan permintaan penghapusan
                        data akun:
                    </p>
                    <ol>
                        <li>
                            Penghapusan akun sama halnya dengan melakukan
                            penutupan/penonaktifan akun.
                        </li>
                        <li>
                            Penghapusan akun hanya dapat diproses apabila sudah
                            tidak ada transaksi yang berjalan di akun kamu,
                            serta tidak memiliki tanggungan lainnya seperti
                            piutang, dll.
                        </li>
                        <li>
                            Data email/nomor handphone pada akun yang sudah
                            dinonaktifkan tidak dapat digunakan kembali atau
                            didaftarkan pada akun lainnya.
                        </li>
                        <li>
                            Pastikan kamu sudah menarik atau menggunakan saldo
                            {{ VUE_ENV.VUE_APP_NAME }} dan Komisi yang kamu
                            miliki.
                        </li>
                    </ol>
                    <p><strong>Cara Hapus Akun</strong></p>
                    <p>
                        Penghapusan/penutupan akun hanya bisa pada Aplikasi
                        {{ VUE_ENV.VUE_APP_NAME }}. Berikut adalah caranya:
                    </p>
                    <ol>
                        <li>
                            Pastikan akun yang ingin dihapus sudah sesuai
                            seperti informasi pada
                            <strong>Syarat & Ketentuan</strong>.
                        </li>
                        <li>
                            Pada menu <b>Akun</b>, kamu bisa pilih menu
                            <b>Atur Akun</b>.
                        </li>
                        <li>
                            Pada menu <b>Atur Akun</b>, kamu bisa pilih menu
                            <b>Hapus Akun</b>.<br />
                            <img
                                :src="
                                    require('@/assets/img_guide_delete_account_1.png')
                                "
                                style="width: 60%"
                                class="img-thumbnail mt-1 mb-1"
                            />
                        </li>
                        <li>
                            Mohon pahami informasi penting berikut untuk Hapus
                            Akun.<br />
                            <img
                                :src="
                                    require('@/assets/img_guide_delete_account_2.png')
                                "
                                style="width: 60%"
                                class="img-thumbnail mt-1 mb-1"
                            />
                        </li>
                        <li>
                            Pilih alasan mengapa kamu ingin Hapus Akun dab
                            berikan detail alasannya.<br />
                            <img
                                :src="
                                    require('@/assets/img_guide_delete_account_3.png')
                                "
                                style="width: 60%"
                                class="img-thumbnail mt-1 mb-1"
                            />
                        </li>
                        <li>
                            Jika kamu sudah yakin, kamu bisa pilih
                            <b>Ya</b>.<br />
                            <img
                                :src="
                                    require('@/assets/img_guide_delete_account_4.png')
                                "
                                style="width: 60%"
                                class="img-thumbnail mt-1 mb-1"
                            />
                        </li>
                        <li>
                            Kami berhasil mengirim pengajuan penghapusan akun
                            kamu.<br />
                            <img
                                :src="
                                    require('@/assets/img_guide_delete_account_5.png')
                                "
                                style="width: 60%"
                                class="img-thumbnail mt-1 mb-1"
                            />
                        </li>
                        <li>
                            Pengajuan kamu akan diproses oleh
                            {{ VUE_ENV.VUE_APP_NAME }} dan akan diinformasikan
                            hasilnya melalui whatsapp.
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    export default {
        data() {
            return {
                loadingContent: true,
            };
        },
        created() {
            setTimeout(() => (this.loadingContent = false), 500);
        },
        computed: {
            ...mapState(['VUE_ENV']),
        },
    };
</script>
